module.exports = __webpack_public_path__ + "img/Ballon_Electrique.25e36762.svg";